import { clsx } from 'clsx';

interface CardProps {
  variant?: 'standard' | 'metric';
  children: React.ReactNode;
  className?: string;
}

export function Card({ variant = 'standard', children, className }: CardProps) {
  return (
    <div
      className={clsx(
        'relative bg-wolf-900/30 border border-wolf-700/50 p-6 transition-all duration-300 hover:border-action/50',
        className
      )}
    >
      {variant === 'metric' && (
        <>
          {/* Top-left corner accent */}
          <div className="absolute top-0 left-0 w-3 h-px bg-action" />
          <div className="absolute top-0 left-0 w-px h-3 bg-action" />
          {/* Top-right corner accent */}
          <div className="absolute top-0 right-0 w-3 h-px bg-action" />
          <div className="absolute top-0 right-0 w-px h-3 bg-action" />
          {/* Bottom-left corner accent */}
          <div className="absolute bottom-0 left-0 w-3 h-px bg-action" />
          <div className="absolute bottom-0 left-0 w-px h-3 bg-action" />
          {/* Bottom-right corner accent */}
          <div className="absolute bottom-0 right-0 w-3 h-px bg-action" />
          <div className="absolute bottom-0 right-0 w-px h-3 bg-action" />
        </>
      )}
      {children}
    </div>
  );
}
